import DataTable, { type DataTableColumn } from '../components/DataTable';
import MetricCard from '../components/MetricCard';
import PageHeader from '../components/PageHeader';
import SectionCard from '../components/SectionCard';
import { StatusBadgeFor } from '../components/StatusBadge';
import { listEmployees } from '../data/mockHelpers';
import type { Employee } from '../data/mock';
import DashboardLayout from '../components/DashboardLayout';
import { dashboardSidebar, dashboardUser, type BusinessPageProps } from './dashboardSidebar';

const employeeColumns: DataTableColumn<Employee>[] = [
  {
    key: 'name',
    header: '姓名',
    cell: (e) => <strong>{e.name}</strong>
  },
  {
    key: 'department',
    header: '部门',
    cell: (e) => e.department
  },
  {
    key: 'title',
    header: '职位',
    cell: (e) => e.title
  },
  {
    key: 'status',
    header: '状态',
    cell: (e) => StatusBadgeFor({ status: e.status })
  },
  {
    key: 'hireDate',
    header: '入职日期',
    cell: (e) => e.hireDate
  }
];

function PeoplePage(props: BusinessPageProps) {
  const rows = listEmployees();
  const activeCount = rows.filter((e) => e.status === '在职').length;
  const trialCount = rows.filter((e) => e.status === '试用期').length;
  const departmentCount = new Set(rows.map((e) => e.department)).size;

  return (
    <DashboardLayout
      sidebar={dashboardSidebar}
      user={dashboardUser}
      pageTitle={{ heading: '员工管理', sub: '' }}
      metrics={[]}
      chart={{ title: '', data: [], xLabels: [] }}
      quickAccess={[]}
      activeSidebarId="people"
      omitPageTitle
      settingsPanel={props.settingsPanel}
      mobileMenu={props.mobileMenu}
      sidebarOpen={props.sidebarOpen}
    >
      <PageHeader
        heading="员工管理"
        sub={`共 ${rows.length} 位员工 · ${departmentCount} 个部门`}
        actions={
          <>
            <button type="button">导出</button>
            <button type="button" className="is-primary">添加员工</button>
          </>
        }
      />
      <div className="axi-section">
        <div className="axi-metric-grid">
          <MetricCard label="在职员工" value={String(activeCount)} unit="人" icon="users" />
          <MetricCard label="试用期" value={String(trialCount)} unit="人" icon="users" neutral />
          <MetricCard label="部门数" value={String(departmentCount)} unit="个" icon="bar" neutral />
          <MetricCard label="平均司龄" value="2.6" unit="年" icon="clock" neutral />
        </div>
      </div>
      <SectionCard
        title="员工名册"
        description="列内容为 mock 数据,占位字段"
      >
        <DataTable<Employee>
          columns={employeeColumns}
          rows={rows}
          rowKey={(e) => e.id}
          caption="按 mock 顺序展示"
        />
      </SectionCard>
    </DashboardLayout>
  );
}

export default PeoplePage;